import canAutoplay from "can-autoplay";
import SimpleCrypto from "simple-crypto-js";
import videojs from "video.js";
// import { options } from "video.js";
// shared variables
var adsManager = null;
var adsRequest = null;
var videoStarted = false; // true when a video has started
var videoComplete = false; // true when a video has ended
var videoSkipped = false;
var videoMaxTime = false; // true if maxAdt is being used and time has elapsed
// var fallbackStarted = false; // true when a fallback ad has started
// var fallbackEnded = false; // true when a fallback ad has completed
var playerClosed = false; // true when the close button has been clicked
var playerClosing = false; // true when the system is in the process of closing
var autoplayAllowed = false; // true if autoplay is allowed for current user
var autoplayRequiresMute = false; // true if autoplay requires mute for current user
var startEvent = 'click'; // type of start event that will not generate an error
var curPageUrl;
var setupAdOpts;
var videoEl = document.getElementById('applixir_video');
var player;
var playerInitialized = false;

// !!!!!! Set this before building !!!!!!!
// var build = "STAGING";
var build = "PRODUCTION";

const play = (options) => {
    // 'use strict';
    var closeInterval; // closeInterval is the ad failsafe timer to keep ads from getting stuck open
    var adCloseInterval; // adCloseInterval is the banner ad timer for fallback

    const onAdsError = (adEvt) => {
        let gameID = options.gameId || 0;
        let error = adEvt.data.AdError;
        let error1 = error.getErrorCode() + "," + error.getInnerError() + "," + error.getType() + "," + error.getVastErrorCode() + ",";
        let error2 = error.getMessage().replace(/ /g, '_');

        if (options.verbosity > 1) {
            console.log('adserror (onAdsError): ' + error1 + error2);
        }
        // zoneId is used on purpose for logging
        var fetchURL;

        if(build === "STAGING")
        {
                fetchURL = 'https://staging-services.applixir.com/ads/callback';
        } else { // production
                fetchURL = 'https://services.applixir.com/ads/callback';
        }
        fetch(fetchURL + '?dev_id=' + options.zoneId + '&game_id=' + gameID + '&custom1=' + error1 + '&custom2=' + error2 + '&watched=' + 0)
            .then((response) => {
                if (response.status === 200) {
                    if (options.verbosity > 4) {
                        console.log("Successful error log write");
                    }
                } else {
                    if (options.verbosity > 4) {
                        console.log("Log write server error: " + JSON.stringify(response));
                    }
                }
            })
            .catch((err) => {
                if (options.verbosity > 0) {
                    console.error('Errorlog callback error:', err);
                }
            });
        /*if (options.fallback == 1) { // 1 == banners
            if (closeInterval) {
                clearInterval(closeInterval);
            }
            if (adCloseInterval) {
                clearInterval(adCloseInterval);
            }
            fallbackStarted = true;
            fallbackEnded = false;
            videoStarted = false;
            parent.postMessage("fallbackStarted", options.pageUrl);
            playFallback(options);
            adCloseInterval = setInterval(() => { // The close timeout for banners is shorter than videos
                fallbackEnded = true;
                if (!(playerClosing || playerClosed)) {
                    playerClosing = true;
                    player.trigger('ad-ended');
                }
                clearInterval(adCloseInterval);
            }, options.btnDelay + 2);
            setTimeout(() => { // this is for the banner close button
                let btn = document.getElementById('btnClose');
                btn.style.display = 'block';
                btn.style.zIndex = 99999999;
            }, options.btnDelay);
        } else { */
            parent.postMessage("videoNotFound", options.pageUrl);
            signalToClose();
//        }
    };

    const onAdsReady = () => {
        if (options.verbosity > 4) {
            console.log('adsready (onAdsReady)');
        }
        if (autoplayAllowed) {
            if (options.verbosity > 4) {
                console.log('autoplay allowed');
            }
            if (autoplayRequiresMute) {
                if (options.verbosity > 4) {
                    console.log('setting muted true');
                }
                player.muted(true);
            } else {
                if (options.muted) {
                    if (options.verbosity > 4) {
                        console.log('options muted true');
                    }
                    player.muted(true);
                } else {
                    if (options.verbosity > 4) {
                        console.log('setting muted false');
                    }
                    player.muted(false);
                }
            }
            player.controls(false);
            if (player.paused()) {
                if (options.verbosity > 4) {
                    console.log("Entering play promise in ads-ready");
                }
                var promise = player.play();
                if (promise !== undefined) {
                    promise.then(function () {
                        // Autoplay started!
                        if (options.verbosity > 4) {
                            console.log('onAdsReady: Autoplay was allowed');
                        }
                    }).catch(function (error) {
                        // Autoplay was prevented.
                        if (options.verbosity > 2) {
                            console.log('Play not allowed, error:' + error);
                        }
                        player.muted(true);
                        player.controls(true);
                        player.bigPlayButton.show();
                    });
                } else {
                    if (options.verbosity > 3) {
                        console.log('Play promise failed, enabling play button');
                    }
                    player.muted(true);
                    player.controls(true);
                    player.bigPlayButton.show();
                }
            }
        } else { // autoplay not allowed
            if (options.verbosity > 3) {
                console.log('autoplay not allowed');
                console.log('setting muted true');
            }
            player.muted(true);
            player.controls(true);
            player.bigPlayButton.show();
        }
    };

    const onAdStart = () => {
        if (options.verbosity > 4) {
            console.log('ads-ad-started (onAdStart)');
        }
        videoStarted = true;
        parent.postMessage("videoStarted", options.pageUrl);
        setTimeout(() => { // this is for the "X" close button.
            document.getElementById('btnClose').style.display = 'block';
        }, options.btnDelay);

        closeInterval = setInterval(() => { // This is the failsafe timer to prevent player hangup
            if (videoComplete) {
                if (!(playerClosing || playerClosed)) {
                    if (options.verbosity > 1) {
                        console.log("Ending on failsafe");
                    }
                    playerClosing = true;
                    player.trigger('ad-ended');
                    clearInterval(closeInterval);
                }
            }
        }, 11000);
        if (options.maxAdt) {
            setTimeout(() => { // this is for the max ad time feature
                videoMaxTime = true;
            }, options.maxAdt);
        }
        /*if (options.isMobile) {
            player.enterFullWindow();
        }*/
        if(options.verbosity > 4) {
            console.log("Duration: " + player.duration().toString());
        }
    };

    const onAdEnded = () => {
        if (options.verbosity > 4) {
            console.log('onAdEnded: vs, fbs, fbe):' + videoStarted /*+ ' ' + fallbackStarted + ' ' + fallbackEnded*/);
        }
        if (videoStarted || playerClosing /* || (fallbackStarted && fallbackEnded)*/) { // are we here from a video or a fallback ad?
            var watched;
            clearInterval(adCloseInterval); // make sure the interval timers doesn't pop
            clearInterval(closeInterval);
            /*if (options.isMobile) {
                player.exitFullWindow();
            }*/
            if (videoComplete || /*fallbackEnded ||*/ videoMaxTime) { // this tells us if the ad or fallback was watched
                watched = 1;
                //let msgText = videoStarted ? "videoWatched" : "videoFallbackBanner";
                parent.postMessage('videoWatched', options.pageUrl);
            } else {
                watched = 0;
                parent.postMessage("videoNotWatched", options.pageUrl);
            }
            var actID = options.accountId || options.devId || undefined;
            if (actID != undefined) { // We can only make a callback if we have a devID
                // The button style is only changed to 'block' after btnDelay seconds, videoComplete == watched
                if (watched === 1) {
                    if (document.getElementById('btnClose').style.display == 'block') {
                        document.getElementById('btnClose').style.display = 'none';
                    }
                    // This sends the server to server callback to the Applixir site for processing then on to
                    // the developer site if they've configured it for this.
                    callRMSendPoint(options);
                } else {
                    signalToClose(); // not watched, close
                }
            } else {
                signalToClose(); // no developer ID, close
            }
            videoStarted = /*fallbackStarted = fallbackEnded =*/ false;
        } else {
            if (!(videoStarted || /*fallbackStarted ||*/ playerClosed)) {
                if (options.verbosity > 2) {
                    console.error('onAdEnd unknown entry');
                }
            }
        }
    };

    const onAdEnd = (event) => {
        if (!playerClosed) {
            if (options.verbosity > 4) {
                console.log('adend (onAdEnd): ' + event);
            }
            setTimeout(() => { // this should only end the session if ended or alladscompleted don't show.
                if (!playerClosing) {
                    playerClosing = true;
                    if (!videoSkipped) {
                        videoComplete = true;
                    }
                    player.trigger('ad-ended');
                }
            }, 2000);
        }
    };

    const onAllAdsCompleted = (event) => {
        if (!playerClosed) {
            if (options.verbosity > 4) {
                console.log('AllAdsCompleted (onAllAdsCompleted): ' + event);
            }
            player.pause();
            if (!playerClosing) {
                if (!videoSkipped && videoStarted) {
                    videoComplete = true;
                }
                playerClosing = true;
                player.trigger('ad-ended');
            }
        }
    };

    const onAdsEnded = (event) => {
        if (!playerClosed) {
            if (options.verbosity > 4) {
                console.log('ads-ad-ended (onAdsEnded): ' + event);
            }
            if (!(playerClosing || videoSkipped)) {
                playerClosing = true;
                videoComplete = true;
                player.trigger('ad-ended');
            }
        }
    };

    const onReadyForPostroll = (event) => {
        if (options.verbosity > 4) {
            console.log('readyforpostroll (onReadyForPostroll): ' + event);
        }
    };

    player.on('alladscompleted', onAllAdsCompleted);
    player.on('adserror', onAdsError);
    player.on('adsready', onAdsReady);
    player.on('ads-ad-started', onAdStart);
    player.on('ads-ad-ended', onAdsEnded);
    player.on('adend', onAdEnd);
    player.on('ad-ended', onAdEnded); // Can only come from close button or triggers
    player.on('readyforpostroll', onReadyForPostroll); //not currently supported

    player.on('ads-request', function (response) {
        adsRequest = response;
        if (options.verbosity > 4) {
            console.log("Player.on: adsRequest " + JSON.stringify(adsRequest));
        }
    });
    player.on('ads-loader', function (response) {
        if (options.verbosity > 4) {
            console.log('Player.on: ads-loader: ' + response);
        }
    });
    player.on('ads-manager', function (response) {
        if (options.verbosity > 4) {
            console.log('Player.on: ads-manager: ' + response);
        }
        adsManager = response;
        player.ima.addEventListener(google.ima.AdEvent.Type.SKIPPED, function () {
            if (options.verbosity > 4) {
                console.log('Player.on: skipped');
            }
            videoSkipped = true;
        });
    });
    player.on('adslog', function (data) {
        console.log('AdError: ' + data.data.AdError);
    });

    player.on(['loadmetadata', 'loaded', 'adplay', 'waiting',
        'firstplay', 'adplaying', 'adfirstplay', 'progress', 'adpause', 'pause', 'ended',
        'contentplaying', 'contentresuming', 'contentpause', 'contentended', 'adstarted',
        'adended', 'ready', 'start', 'error', 'emptied', 'stalled', 'suspend',
        // 'play', 'playing', 'contentfirstplay', 'contentplay', 'loadeddata', 'canplaythrough', 'seeking', 'seeked', 'canplay', 
    ], function (e) {
        if (options.verbosity > 4 && !playerClosed) {
            console.log('VIDEOJS player event: ', e.type);
        }
    });
};

function iframeHtmlOnload() {
    console.log("readyState: " + document.readyState);
};

const invokeApplixirPlayer = () => {
    var options = {};
    var dataLoaded = false; // True when the data options have been loaded
    const newBtn = document.createElement('button');
    videoEl = document.getElementById('applixir_video');
    options.pass2 = false;

    newBtn.type = 'button';
    newBtn.id = 'btnClose';
    newBtn.style.display = 'none';
    newBtn.innerHTML = "X";
    newBtn.style.position = "absolute";
    newBtn.style.zIndex = 99999;
    newBtn.setAttribute('width', 10);
    newBtn.setAttribute('height', 10);
    newBtn.setAttribute('maxWidth', 12);
    newBtn.style.top = "0px";

    curPageUrl = window.location.protocol + "//" + window.location.hostname;

    function ifrmInit(event) {
        /*if(event.source != options.pageUrl || event.source != "https://cdn.applixir.com") {
            console.log("Invalid postMessage from: " + event.source);
            return;
        }*/

        if (dataLoaded === false && event.data.indexOf("videoOptionsDataSet") == 0) {
            dataLoaded = true;
            options = JSON.parse(event.data.substring(20));

            if (options.verbosity > 2) {
                console.log("Content page: " + curPageUrl);
                if (curPageUrl.substring(window.domain) === -1) {
                    console.log("window.domain: " + window.domain);
                }
            }

            if (!options.btnDelay) {
                options.btnDelay = 16000;
            } else if (options.btnDelay < 11) {
                options.btnDelay = 11000;
            } else if (options.btnDelay > 31) {
                options.btnDelay = 31000;
            } else {
                options.btnDelay = options.btnDelay * 1000;
            }

            if (options.maxAdt) {
                if (options.maxAdt < 31) {
                    options.maxAdt = 31000;
                } else if (options.maxAdt > 120) {
                    options.maxAdt = 120000;
                } else {
                    options.maxAdt = options.maxAdt * 1000;
                }
            }

            videoEl.style.transform = "scale(" + Math.min(Math.min(options.curW / options.targetW, options.curH / options.targetH), 1) + ")";
            videoEl.style.transformOrigin = "top left";
            //videoEl.style.position = "absolute";
            videoEl.style.width = options.targetW + "px";
            videoEl.style.height = options.targetH + "px";
            videoEl.style.overflow = "hidden";
            videoEl.style.left = "auto";
            videoEl.style.top = "auto";
            videoEl.style.margin = "0 auto";
            if (options.verbosity > 4) {
                console.log("Video parameters - transform:" + videoEl.style.transform + " width: " + videoEl.style.width + " height: " + videoEl.style.height);
            }

            checkUnmutedAutoplaySupport(options);

            if (options.nopers === true) {
                if (options.verbosity > 4) {
                    console.log("Non-personalized ads enabled");
                }
            }
            if (options.nodata === true) {
                if (options.verbosity > 4) {
                    console.log("Restricted data processing enabled");
                }
            }
            newBtn.style.left = options.targetW + 'px';
            newBtn.onclick = function () {
                var r;
                if(options.rewarded) {
                    window.postMessage('closeGPTPlayer', curPageUrl);
                } else if (videoComplete) {
                    r = true;
                } else {
                    if (options.confirm === true) {
                        r = confirm("Closing the player now will forfeit your reward. Are you sure?");
                    } else {
                        r = true;
                    }
                }
                if (r == true) {
                    if (player) {
                        if (videoStarted) {
                            player.ima.pauseAd();
                        }
                        /*if (fallbackStarted) {
                            fallbackEnded = true;
                        }*/
                        if (!(playerClosing || playerClosed)) {
                            playerClosing = true;
                            player.trigger('ad-ended');
                        }
                    } else {
                        console.log('videoEl.player null onclick');
                    }
                }
            };
            document.body.appendChild(newBtn);

        } else if (event.data === 'initApplixirAd') { // init->play sequence (this mode does not support GPT-rewarded)
            initPlayer(options);
        } else if (event.data === 'displayApplixirAd') {
            if (options.rewarded === true) {
                // Slot returned null in parent - the page or device does not support rewarded ads.
                if(options.verbosity > 2) {
                    console.log('rewardedSlot failed');
                }
                options.rewarded = false;
                initPlayer(options); // This will fall back to an IMA video ad
            } else {  // options.rewarded !== true
                if (videoEl && player) {
                    if (options.verbosity > 4) {
                        console.log('play at eventListener');
                    }
                    play(options);
                } else {
                    if (videoEl == null) {
                        if (options.verbosity > 0) {
                            console.error('videoEl is null at eventListener');
                        }
                    } else {
                        if (options.verbosity > 0) {
                            console.error('player is null at eventListener');
                        }
                    }
                    signalToClose();
                }
            }
        } else if (event.data === 'callRMSendpoint') {
            callRMSendPoint(options);
        } else if (event.data === 'closeApplixirPlayer') {
            let player = videojs('applixir_video');
            /*if (fallbackStarted) {
                let backupEl = document.getElementById('appprizes-backup');
                backupEl.style.zIndex = 1;
                backupEl.style.display = 'none';
            }*/
            player.controls(false);
            player.currentTime(0);
            player.hasStarted(false);
            if (options.endMsg != undefined && options.endMsg > 0) {
                if (options.endMsg > 2) {
                    options.endMsg = 2;
                }
                if (options.verbosity > 4) {
                    this.console.log("Preparing exit poster");
                }
                player.poster("https://cdn.applixir.com/applixir2.jpg");
                player.posterImage.show();
                setTimeout(() => { // this is for the "Thankyou" poster.
                    if (options.verbosity > 4) {
                        console.log('CloseApplixirPlayer');
                    }
                    parent.postMessage('closeApplixirPlayer', options.pageUrl);
                    window.removeEventListener('message', ifrmInit, false);
                    if (videoStarted) {
                        let player = videojs('applixir_video');
                        player.ima.pauseAd();
                    }
                    playerClosed = true;
                }, options.endMsg * 1000);
            } else {
                if (options.verbosity > 3) {
                    console.log('CloseApplixirPlayer');
                }
                window.removeEventListener('message', ifrmInit, false);
                parent.postMessage('closeApplixirPlayer', options.pageUrl);
                if (videoStarted) {
                    let player = videojs('applixir_video');
                    player.ima.pauseAd();
                }
                playerClosed = true;
            }
        } else if (event.data === 'closeGPTplayer') {
            window.removeEventListener('message', ifrmInit, false);
            parent.postMessage('closeApplixirPlayer', options.pageUrl);
        } 
    };
    window.addEventListener('message', ifrmInit, false);

    parent.postMessage("applixirIframeReady", "*");

};

const signalToClose = () => {
    window.postMessage('closeApplixirPlayer', curPageUrl.includes("localhost") ? curPageUrl + ":" + window.location.port : curPageUrl);
};

const searchObj = (obj, str) => {
    let vstr = "";
    for (let key in obj) {
        let value = obj[key];
        if (typeof value === 'object') {
            searchObj(value, str);
        }
        vstr = vstr + value;
    }
    if (vstr.indexOf(str) != -1) {
        return true;
    } else {
        return false;
    }
};

function setAdOptions(str) {
    return new SimpleCrypto(str);
}

function formatAdOpts(obj) {
    return encodeURIComponent(setupAdOpts.encrypt(obj));
}

function parseAdOpts(options) {
    let adOpts = JSON.parse(setupAdOpts.decrypt(options.return));
    if(options.verbosity === 5) {
        console.log("adOpts: " + JSON.stringify(adOpts));
    }
    options.adblock = adOpts.key;
    options.return = adOpts.sid;
    options.rAdUnit = adOpts.iu;
    options.cparms = adOpts.cust_params;
    setupAdOpts.setSecret(adOpts.key);
}

function extend(obj) {
    var arg, i, k;
    for (i = 1; i < arguments.length; i++) {
        arg = arguments[i];
        for (k in arg) {
            if (arg.hasOwnProperty(k)) {
                if (isObject(obj[k]) && !isNull(obj[k]) && isObject(arg[k])) {
                    obj[k] = extend({}, obj[k], arg[k]);
                } else {
                    obj[k] = arg[k];
                }
            }
        }
    }
    return obj;
}

function isNull(o) {
    return o === null;
}

function isObject(obj) {
    return typeof obj === 'object';
}

function checkUnmutedAutoplaySupport(options) {
    canAutoplay
        .video({
            timeout: 100,
            muted: false
        })
        .then(function (response) {
            if (response.result === false) {
                // Unmuted autoplay is not allowed.
                checkMutedAutoplaySupport(options);
            } else {
                // Unmuted autoplay is allowed.
                autoplayAllowed = true;
                autoplayRequiresMute = false;
                initAdParameters(options);
            }
        })
}

function checkMutedAutoplaySupport(options) {
    canAutoplay
        .video({
            timeout: 100,
            muted: true
        })
        .then(function (response) {
            if (response.result === false) {
                // Muted autoplay is not allowed.
                autoplayAllowed = false;
                autoplayRequiresMute = false;
            } else {
                // Muted autoplay is allowed.
                autoplayAllowed = true;
                autoplayRequiresMute = true;
            }
            initAdParameters(options);
        })
}

const initAdParameters = (options) => {
    var actID = options.devId || options.accountId || undefined;
    var fetchURL;

    if(build === "STAGING") {
        fetchURL = 'https://staging-services.applixir.com/ads/foobar';
    } else { 
        fetchURL = 'https://services.applixir.com/ads/foobar';
    }
    fetch(fetchURL + '?account_id=' + actID + '&game_id=' + options.gameId + '&zone_id=' + options.zoneId, {
        method: "GET",
        headers: {
            'Accept': '*/*',
            'Content-Type': 'text/plain',
        },
        credentials: "include"
    }).then((response) => {
        if (response.status !== 200) {
            if (options.verbosity > 4) {
                console.log("response: " + response.status);
            }
            throw 'response.status is not 200!';
        }
        response.text().then((text) => {
            if (options.verbosity > 4) {
                console.log("text: " + JSON.stringify(text));
            }
            options.adblock = text.substring(17, 17 + 32);
            options.return = text.substring(69);
            setupAdOpts = setAdOptions(options.adblock);
            parseAdOpts(options);
            if(options.rAdUnit === false) {
                options.rAdUnit = "";
                options.rewarded = false;
            } else {
                options.rewarded = true;
            }
            if (options.verbosity > 4) {
                console.log("Settings1: " + JSON.stringify(options));
            }
            parent.postMessage("setGParameters=" + options.rAdUnit, options.pageUrl);
            if (options.startMode === 3) { // startMode 3 == invoke
                initPlayer(options);
            }
        }).catch((err) => {
            console.log('text/decrypt ' + err);
        });
    }).catch((err) => {
        console.log('open/send error: ' + err);
    });
}


const callRMSendPoint = (options) => {

    var actID = options.accountId || options.devId;
    var adOpts = {
        timeStamp: Date.now(),
        devId: actID,
        gameId: options.gameId,
        custom1: options.userId || options.custom1 || '0',
        custom2: options.custom || options.custom2 || '0',
    };
    
    if (adOpts.custom1 === '0') {
        if (options.verbosity > 4) {
            console.log("RMS call failed, invalid userId");
            signalToClose(); // don't let player window hang there
            return;
        }
    }
    var adOptions = formatAdOpts(adOpts);
    var fetchURL;

    // staging
    if(build === 'STAGING') {
            fetchURL = 'https://staging-services.applixir.com/ads/callback';
    } else {
            fetchURL = 'https://services.applixir.com/ads/callback';
    }
    fetch(fetchURL + '?dev_id=' + actID + '&game_id=' + options.gameId + '&custom1=' + 0 + '&custom2=' + adOptions + '&watched=' + 1 + '&sid=' + options.return, {
        method: "GET",
        headers: {
            'Accept': '*/*',
            'Content-Type': 'text/plain',
        },
        credentials: 'include'
    })
    .then((response) => { // note: this is a delayed call
        if (response.status === 200) {
            if (options.verbosity > 4) {
                console.log("RMS call successful");
            }
            response.text().then((text) => {
                if (options.verbosity > 4) {
                    console.log("text: " + text);
                }
                if (text.includes("OK")) {
                    parent.postMessage("rewardGranted", options.pageUrl);
                } else if (text.includes("Endpoint Rejected")) {
                    parent.postMessage("rewardRejected", options.pageUrl);
                } else if (text.includes("Rate Violation")) {
                    parent.postMessage("rewardViolation", options.pageUrl);
                } else if (text.includes("Maximum Rewards")) {
                    parent.postMessage("rewardMaxed", options.pageUrl);
                }
                signalToClose(); // wait to close until all delayed processing is complete.
            });
        } else {
            if (options.verbosity > 4) {
                console.log("callback server error: " + JSON.stringify(response));
            }
            signalToClose();
        }
    })
    .catch((err) => {
        console.error('RMS call error:', err);
        signalToClose(); // don't let player window hang there
        // we exit now from failure mode - note this is a delayed call
    });
}

const initPlayer = (options) => {
    let zoneID = (options.isMobile && options.zoneIdM ? options.zoneIdM : options.zoneId);
    let adUrl = null;

    if(build === 'STAGING') {
        adUrl = typeof (options.adTagUrl) != 'undefined' ? options.adTagUrl : 'https://staging-services.applixir.com/ads/tags/' + options.gameId + '/' + zoneID +'/vast';
    } else {  // Production
        adUrl = typeof (options.adTagUrl) != 'undefined' ? options.adTagUrl : 'https://services.applixir.com/ads/tags/' + options.gameId + '/'+ zoneID +'/vast';
    }
    let cKeywords = typeof (options.cKeywords) != 'undefined' ? options.cKeywords : 'entertainment';
    let cTitle = typeof (options.cTitle) != 'undefined' ? options.cTitle : 'game';

    if (options.verbosity > 4) {
        console.log("initPlayer - auto: " + autoplayAllowed + " mute: " + autoplayRequiresMute);
    }

    if(options.rewarded === true) {
        if (options.verbosity > 4) {
            console.log("GPT Enabled"); // Settings: " + JSON.stringify(options));
        }
        var xBtn = document.getElementById('btnClose');
        setTimeout(() => { // this is for the "X" close button.
            xBtn.style.display = 'block';
        }, options.btnDelay);
    } else {

        var imaOptions = {
            adTagUrl: adUrl,
            adLabel: options.zoneId === 2050 ? 'Applixir Test Ad' : 'Applixir Video',
            forceNonLinearFullSlot: true,
            vpaidMode: options.vpaidMd || 'ENABLED',
            ppid: options.userId,
            pageUrl: options.pageUrl,
            vastLoadTimeout: 10000,
            contribAdSettings: {
                prerollTimeout: 10000,
                timeout: 10000,
                debug: options.verbosity > 3 ? true : false,
            },
            adsRequest: {
                linearAdSlotWidth: options.targetW,
                linearAdSlotHeight: options.targetH,
                nonLinearAdSlotWidth: options.targetW,
                nonLinearAdSlotHeight: Math.floor(options.targetH / 3)
            },
        };
        let _options = options;
        let settings = extend({}, imaOptions, _options);
        if (options.verbosity > 4) {
            console.log("IMA Settings: " + JSON.stringify(settings));
        }

        if(!player) {
            var vjsOptions = {
                autoplay: autoplayAllowed,
                muted: autoplayRequiresMute,
                crossorigin: "anonymous",
                playsinline: true,
                responsive: true,
                //fill: true,
                fullscreen: {
                    options: {
                        navigationUI: "show",
                    }
                }
            };
            player = videojs("applixir_video", vjsOptions, function () {
                if (options.verbosity > 4) {
                    console.log("Entering play promise in player ready");
                }
                var promise = player.play();
                if (promise !== undefined) {
                    promise.then(function () {
                        // Autoplay started!
                        if (options.verbosity > 4) {
                            console.log('initPlayer: Autoplay was allowed');
                        }
                    }).catch(function (error) {
                        // Autoplay was prevented.
                        if (options.verbosity > 2) {
                            console.log('Play not allowed, error:' + error);
                        }
                        player.muted(true);
                        player.controls(true);
                        player.bigPlayButton.show();
                    });
                } else {
                    if (options.verbosity > 3) {
                        console.log('Play promise failed, enabling play button');
                    }
                    player.muted(true);
                    player.controls(true);
                    player.bigPlayButton.show();
                }
            });
            player.responsive(true);
        }
        player.ima(imaOptions);

        if (!autoplayAllowed) {
            if (navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/Android/i)) {
                    startEvent = 'touchend';
            }
        }
        videoEl.addEventListener(startEvent, initAdDisplayContainer);
    }
    parent.postMessage('videoInitialized', options.pageUrl);
};

function initAdDisplayContainer(event) {
    playerInitialized = true;
    console.log("Player initialized");
    player.ima.initializeAdDisplayContainer();
    videoEl.removeEventListener(startEvent, initAdDisplayContainer);
}

window.mobilecheck = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

window.invokeApplixirPlayer = invokeApplixirPlayer;